import { motion } from "framer-motion";

export const UpgradeItem = ({
  choosenItem,
  itemsData,
  setActiveItem,
  setOpenItems,
  openItemsClick,
  openItems,
  greyImage,
  itemType,
  itemNumber,
  isButtonActive,
}) => {
  return (
    <div
      style={{ backgroundColor: choosenItem?.itemInfo?.color }}
      className="upgrade-items"
    >
      {!choosenItem?.title && (
        <motion.img
          whileTap={{
            scale: 0.9,
          }}
          transition={{ duration: 0.05 }}
          onClick={() => {
            if (isButtonActive) {
              openItemsClick(itemNumber);
            }
          }}
          width={"90%"}
          src={greyImage}
        ></motion.img>
      )}

      {choosenItem?.title && (
        <>
          <motion.div
            whileTap={{
              scale: 0.9,
            }}
            transition={{ duration: 0.1 }}
            onClick={() => {
              if (isButtonActive) {
                setActiveItem();
                setOpenItems(null);
              }
            }}
            style={{
              position: "absolute",
              top: -12,
              right: -12,
              width: 32,
              height: 32,
              backgroundColor: "black",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 10,
              zIndex: 7,
            }}
          >
            ✕
          </motion.div>
          <motion.img
            whileTap={{
              scale: 0.9,
            }}
            transition={{ duration: 0.05 }}
            onClick={() => {
              if (isButtonActive) {
                openItemsClick(itemNumber);
              }
            }}
            width={"90%"}
            src={choosenItem?.itemInfo?.miniimg}
          ></motion.img>
          <div
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              backgroundColor: "rgba(0, 0, 0, 0.65)",
              color: "rgba(255, 255, 255, 0.9)",
              padding: "3px 6px",
              borderRadius: 8,
              fontSize: 12,
            }}
          >
            {choosenItem?.quantity}
          </div>
        </>
      )}
      {openItems === itemNumber && (
        <div className="upgrade-items-list">
          {itemsData.map((item) => {
            if (item.type === itemType)
              return (
                <motion.div
                  whileTap={{
                    scale: 0.9,
                  }}
                  transition={{ duration: 0.05 }}
                  onClick={() => {
                    setActiveItem(item);
                    setOpenItems(null);
                  }}
                  style={{ backgroundColor: item.itemInfo?.color }}
                  className="upgrade-items"
                  key={item.title}
                >
                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      top: 0,
                      backgroundColor: "rgba(0, 0, 0, 0.65)",
                      color: "rgba(255, 255, 255, 0.9)",
                      padding: "3px 6px",
                      borderRadius: 8,
                      fontSize: 12,
                    }}
                  >
                    {item.quantity}
                  </div>
                  <img
                    width={"90%"}
                    src={item.itemInfo?.miniimg}
                    alt={item.title}
                  />
                </motion.div>
              );
          })}
        </div>
      )}
    </div>
  );
};
